import { useContext } from 'react';
import { assign } from 'xstate';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';

import { GlobalStateContext } from '../contexts';
import { undoCancelation, SetErrorEvent } from '../machines/undoCancelation';

export const useUndoCancelationService = (
  catalogId: number,
  subscriptionId: number
) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useContext(GlobalStateContext);
  return useInterpret(undoCancelation, {
    services: {
      undoCancelation: () => {
        return dataAccess.undoCancelation(subscriptionId);
      },
    },
    actions: {
      updateSubscription: () => {
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          catalogId,
          subscriptionId,
          scheduledCancellationAt: null,
          status: 'active',
        });
      },
      setError: assign((context, event: SetErrorEvent) => {
        return {
          ...context,
          error: event.data,
        };
      }),
    },
  });
};
